// Slider Progressbar Logic
{
    const sliderComponents = document.querySelectorAll('.testimonials-slider__slider');

    sliderComponents.forEach(sliderList => {
        const sliderComponent = sliderList.closest('slider-component');
        if (!sliderComponent) return;

        const slider = sliderComponent.querySelector('.slider');
        const progressBar = sliderComponent.querySelector('.slider-progress-bar__indicator');

        if (!slider || !progressBar) return;

        function updateProgressBar() {
            const scrollLeft = slider.scrollLeft;
            const scrollWidth = slider.scrollWidth;
            const clientWidth = slider.clientWidth;

            const maxScroll = scrollWidth - clientWidth;
            if (maxScroll <= 0) {
                progressBar.style.width = '100%';
                return;
            }
            
            const percentage = (scrollLeft / maxScroll) * 100;
            progressBar.style.width = `${Math.max(0, Math.min(100, percentage))}%`;
        }

        slider.addEventListener('scroll', updateProgressBar);
        window.addEventListener('resize', updateProgressBar);
        updateProgressBar();
    });
}

{
    (() => {
        const quizSections = document.querySelectorAll('.js-section-quiz');
        if (!quizSections.length) return;

        quizSections.forEach(section => {
            const steps = section.querySelectorAll('.js-quiz-step');
            const resultWrapper = section.querySelector('.js-quiz-result');
            if (!steps.length || !resultWrapper) return;

            const scores = {};

            const stepSelections = new Map();

            steps.forEach((step, stepIndex) => {
                const radios = step.querySelectorAll('input[type="radio"]');
                const nextBtn = step.querySelector('.js-quiz-btn-next');
                const lastBtn = step.querySelector('.js-last-step-btn');

                const jsonScript = step.querySelector('.js-quiz-block-data[type="application/json"]');
                if (!jsonScript) return;

                const stepData = JSON.parse(jsonScript.textContent);

                radios.forEach(radio => {
                    radio.addEventListener('change', () => {
                        const answerIndex = Number(radio.value) - 1;
                        const answerData = stepData.answers[answerIndex];
                        if (!answerData) return;
                        
                        const productConfig = answerData.products[0];
                        
                        if (stepSelections.has(step)) {
                            stepSelections.get(step).forEach(({ product, points }) => {
                                scores[product] -= points;
                            });
                        }

                        const applied = [];

                        // ---- P1 (always)
                        if (productConfig.p1_product) {
                            const p = productConfig.p1_product;
                            const pts = Number(productConfig.p1_points || 0);

                            scores[p] = (scores[p] || 0) + pts;
                            applied.push({ product: p, points: pts });
                        }

                        // ---- P2 (conditional)
                        if (productConfig.p2_enabled && productConfig.p2_product) {
                            const p = productConfig.p2_product;
                            const pts = Number(productConfig.p2_points || 0);

                            scores[p] = (scores[p] || 0) + pts;
                            applied.push({ product: p, points: pts });
                        }

                        // ---- P3 (conditional)
                        if (productConfig.p3_enabled && productConfig.p3_product) {
                            const p = productConfig.p3_product;
                            const pts = Number(productConfig.p3_points || 0);

                            scores[p] = (scores[p] || 0) + pts;
                            applied.push({ product: p, points: pts });
                        }

                        stepSelections.set(step, applied);

                        nextBtn?.removeAttribute('disabled');
                        lastBtn?.removeAttribute('disabled');
                    });
                });

                // Navigation
                nextBtn?.addEventListener('click', () => {
                    step.classList.remove('active');
                    steps[stepIndex + 1]?.classList.add('active');
                });

                lastBtn?.addEventListener('click', () => {
                    step.classList.remove('active'); 
                    showResult(scores, resultWrapper);
                });
            });
        });

        function showResult(scores, wrapper) {
            wrapper.classList.add('active');
            wrapper.querySelectorAll('.js-result-product').forEach(el => el.classList.add('hidden'));

            const maxScore = Math.max(...Object.values(scores));

            const winners = Object.entries(scores).filter(([, score]) => score === maxScore).map(([product]) => product);

            const finalWinner = winners.length > 1 ? 'product_3' : winners[0];

            const productMap = {
                product_1: 1,
                product_2: 2,
                product_3: 3
            };

            wrapper.querySelector(`.js-quiz-result-product-${productMap[finalWinner] || 3}`).classList.remove('hidden');
        }
    })();
}

// Scroll to Quiz Section
{
    var buttons = document.querySelectorAll('.js-scroll-to-quiz');
    buttons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            var quizSection = document.getElementById('quiz-section');
            if (quizSection) {
                quizSection.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
}

/* Mobile Menu */
{
    const toggles = document.querySelectorAll('.js-mobile-menu-toggle');
    const closes = document.querySelectorAll('.js-mobile-menu-close');
    const drawer = document.querySelector('.js-mobile-drawer');
    const menuLinks = document.querySelectorAll('.landing-header__drawer-link');

    toggles.forEach(toggle => {
        toggle.addEventListener('click', function() {
            if (drawer) {
                drawer.classList.add('is-open');
                document.body.style.overflow = 'hidden';
                
                const announcementBar = document.querySelector('.landing-announcement');
                if (announcementBar) {
                    announcementBar.style.display = 'none';
                }
            }
        });
    });

    closes.forEach(close => {
        close.addEventListener('click', function() {
            if (drawer) {
                drawer.classList.remove('is-open');
                document.body.style.overflow = '';

                const announcementBar = document.querySelector('.landing-announcement');
                if (announcementBar) {
                    announcementBar.style.display = '';
                }
            }
        });
    });

    menuLinks.forEach(link => {
        link.addEventListener('click', function() {
            if (drawer) {
                drawer.classList.remove('is-open');
                document.body.style.overflow = '';

                const announcementBar = document.querySelector('.landing-announcement');
                if (announcementBar) {
                    announcementBar.style.display = '';
                }
            }
        });
    });

    // Smooth Scroll for Anchor Links (Mobile & Desktop)
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                e.preventDefault();
                
                // Scroll with offset
                // const headerHeight = document.querySelector('.landing-section-header')?.offsetHeight || 0;                
                const offsetPosition = targetElement.getBoundingClientRect().top + window.scrollY;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        });
    });
}

// add class in body as per os
{
    getBroswerDetails();
    const userAgent = navigator.userAgent.toLowerCase();
    let browserName = '';
    
    if (navigator.brave && navigator.brave.isBrave) {
        navigator.brave.isBrave().then((isBrave) => {
            if (isBrave) {
                document.body.classList.add('browser-brave');
            } else {
                detectBrowser();
            }
        });
    } else {
        detectBrowser();
    }
    
    function detectBrowser() {
        if (userAgent.includes('edge')) {
            browserName = 'edge';
        } else if (userAgent.includes('chrome')) {
            browserName = 'chrome';
        } else if (userAgent.includes('firefox')) {
            browserName = 'firefox';
        } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
            browserName = 'safari';
        } else if (userAgent.includes('opr') || userAgent.includes('opera')) {
            browserName = 'opera';
        } else if (userAgent.includes('msie') || userAgent.includes('trident')) {
            browserName = 'ie';
        }
        
        if (browserName) {
            document.body.classList.add('browser-' + browserName);
        }
    }

    function getBroswerDetails() {
        //Checking the user's OS and Browser
        if ((navigator.userAgent).includes("Android")) {
            document.querySelector("html").classList.add("android");
        } else if ((navigator.userAgent).includes("Mac")) {
            document.querySelector("html").classList.add("mac");
        } else {
            document.querySelector("html").classList.add("windows");
        }
    }
}